export const ADD_SHIPMENT_LABEL_SUCCESS = "ADD_SHIPMENT_LABEL_SUCCESS";
export const ADD_SHIPMENT_LABEL_REQUEST = "ADD_SHIPMENT_LABEL_REQUEST";
export const ADD_SHIPMENT_LABEL_FAILURE = "ADD_SHIPMENT_LABEL_FAILURE";
export const ADD_SHIPMENT_LABEL_RESET = "ADD_SHIPMENT_LABEL_RESET";
export const addShipmentLabelSuccess = (payload) => ({
    type: ADD_SHIPMENT_LABEL_SUCCESS,
    payload,
});
export const addShipmentLabelRequest = (payload) => ({
    type: ADD_SHIPMENT_LABEL_REQUEST,
    payload,
});
export const addShipmentLabelFailure = (payload) => ({
    type: ADD_SHIPMENT_LABEL_FAILURE,
    payload,
});
export const addShipmentLabelReset = () => ({
    type: ADD_SHIPMENT_LABEL_RESET,
});
